<div class="modal-header">
  <h4 class="modal-title">{{ headerText }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="row">
    <div class="form-group col-6">
      <label for="nameInput">Name</label>
      <input id="nameInput" type="text" name="name"
             required="required"
             class="form-control"
             [(ngModel)]="fee.name">
      <div class="form-text text-danger">{{ errors.name }}</div>
    </div>
    <div class="form-group col-6">
      <label for="feeInput">Amount</label>
      <input id="feeInput" type="number" name="fee"
             required="required" min="0" step="0.01"
             class="form-control"
             [(ngModel)]="fee.fee">
      <div class="form-text text-danger">{{ errors.fee }}</div>
    </div>
  </div>

  <div class="form-group" *ngIf="useIncludesEntryField">
    <div class="form-check">
      <input id="includesEntryInput" type="checkbox" value="" name="includes_entry"
             class="form-check-input"
             [(ngModel)]="fee.includes_entry">
      <label class="form-check-label" for="includesEntryInput">
        <ng-container *ngIf="usePerBookingFields">
          Include facility entry for all participants on the booking when this fee is chosen (entry only valid during the booked event).
        </ng-container>
        <ng-container *ngIf="!usePerBookingFields">
          Include facility entry for the participant when this fee is chosen (entry only valid during the booked event).
        </ng-container>
      </label>
    </div>
  </div>

  <div class="form-group" *ngIf="useSellVoucherViaPOSField">
    <div class="form-check">
      <input id="sellVoucherViaPOSInput" type="checkbox" value="" name="sell_voucher_via_pos"
             class="form-check-input"
             [(ngModel)]="fee.sell_voucher_via_pos">
      <label class="form-check-label" for="sellVoucherViaPOSInput">
        Sell event vouchers using this fee in your POS.
      </label>
    </div>
  </div>

  <ng-container *ngIf="usePerBookingFields">
    <div class="form-group">
      <div class="form-check">
        <input id="limitNumberOfParticipantsInput" type="checkbox" value="" name="limitNumberOfParticipants"
               class="form-check-input"
               [(ngModel)]="limitNumberOfParticipants">
        <label class="form-check-label" for="limitNumberOfParticipantsInput">
          Limit the number of participants which are included with this per-booking fee.
        </label>
      </div>
    </div>

    <ng-container *ngIf="limitNumberOfParticipants">
      <div class="row">
        <div class="form-group col-6">
          <label for="includedParticipantsInput">Number of Included Participants</label>
          <input id="includedParticipantsInput" type="number" name="included_participants"
                 required="required" min="1" step="1" class="form-control"
                 [(ngModel)]="fee.included_participants">
          <div class="form-text text-danger">{{ errors.included_participants }}</div>
        </div>
      </div>

      <div class="form-group">
        <div class="form-check">
          <input id="includeFeePerAdditionalParticipantInput" type="checkbox" value=""
                 name="includeFeePerAdditionalParticipant"
                 class="form-check-input"
                 [(ngModel)]="includeFeePerAdditionalParticipant">
          <label class="form-check-label" for="includeFeePerAdditionalParticipantInput">
            Allow additional participants to be included, beyond the above number, with an additional fee per participant.
          </label>
        </div>
      </div>

      <ng-container *ngIf="includeFeePerAdditionalParticipant">
        <div class="row">
          <div class="form-group col-6">
            <label for="additionalParticipantFeeInput">Fee per Additional Participant</label>
            <input id="additionalParticipantFeeInput" type="number" name="additional_participant_fee"
                   required="required" min="0" step="0.01"
                   class="form-control"
                   [(ngModel)]="fee.additional_participant_fee">
            <div class="form-text text-danger">{{ errors.additional_participant_fee }}</div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="useAllowMultipleCopiesField">
    <div class="form-group">
      <div class="form-check">
        <input id="allowMultipleCopiesInput" type="checkbox" value=""
               name="allowMultipleCopies"
               class="form-check-input"
               [(ngModel)]="allowMultipleCopies">
        <label class="form-check-label" for="allowMultipleCopiesInput">
          Allow customers to purchase multiple copies of this add-on.
          <small class="d-block text-muted" *ngIf="isPerParticipantAddOn">
            This setting controls how many copies a single participant may
            select. Each participant in the booking may select this add-on
            independently, regardless of this setting.
          </small>
        </label>
      </div>
    </div>

    <ng-container *ngIf="allowMultipleCopies">
      <div class="row">
        <div class="form-group col-6">
          <label for="maxCopiesInput">Maximum Number of Copies</label>
          <input id="maxCopiesInput" type="number" name="max_copies"
                 required="required" min="2" max="1000" step="1"
                 class="form-control"
                 [(ngModel)]="fee.max_copies">
          <div class="form-text text-danger">{{ errors.max_copies }}</div>
        </div>
        <div class="form-group col-6">
          <label for="multipleCopiesInputTypeInput">Customer Input Style</label>
          <select id="multipleCopiesInputTypeInput"
                  name="multiple_copies_input_type"
                  class="custom-select"
                  [(ngModel)]="fee.multiple_copies_input_type">
            <option value="input">Number input</option>
            <option value="dropdown">Dropdown</option>
          </select>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="activeModal.close()">
    Cancel
  </button>
  <button class="btn btn-primary"
          (click)="handleSubmit()">
    Submit
  </button>
</div>
